import {Button, Form, Input, InputNumber, message, Select} from "antd";
import React from "react";
import {LaborPost, LaborRemove, LaborUpdate} from "../../../../../models/crm/labor";
import {LaborNameFilter} from "../../../../../filters/crm/LaborName";
import _ from 'lodash'
import {DisposalRemove} from "../../../../../models/crm/disposal";

const FormItem = Form.Item;
const Option = Select.Option;

class LaborForm extends React.Component {
    state = {
        data: [],
        update: false,
        btn_text: 'Add Labor',
        update_item: null
    };

    handleLaborSubmit = () => {
        const {data, update, update_item} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (update)
                    LaborUpdate(update_item.id, values)
                        .then(response => {
                            const index = _.findIndex(data, {id: update_item.id});
                            data.splice(index, 1, response);
                            this.setState({data, update: false, btn_text: "Add Labor", update_item: null});
                            this.props.onChange(data.map(item => item.id));
                            message.success("Labor updated successfully");
                            this.resetFields();
                        });
                else
                    LaborPost(values)
                        .then(response => {
                            data.push(response);
                            this.setState({data, update: false, btn_text: "Add Labor", update_item: null});
                            this.props.onChange(data.map(item => item.id));
                            message.success("Labor added successfully");
                            this.resetFields()
                        })
            }
        })
    };
    resetFields = () => {
        this.props.form.resetFields();
        this.labor_name.handleChange()
    };
    fillUpdateFields = (item) => {
        this.props.form.setFieldsValue({
            description: item.description,
            time: item.time,
            uot: item.uot,
            custom_cost: item.custom_cost,
        });
        this.labor_name.handleChange({key: item.labor_name.id, label: item.labor_name.label});
        this.setState({update: true, btn_text: "Update Labor", update_item: item})
    };

    removeData = (item) => {
        const {data} = this.state;
        LaborRemove(item.id)
            .then(() => {
                message.success("Labor Removed");
                _.remove(data, {id: item.id});
                this.props.onChange(data.map(item => item.id));
                this.setState({data})
            })
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {data, btn_text} = this.state;
        return (
            <div className="labor-tab">
                <div className="row">
                    <div className="col-sm-6 col-12">
                        <div className="floating-label">
                            <FormItem label="Role">
                                {getFieldDecorator('labor_name', {
                                    rules: [{
                                        required: true,
                                        message: 'Please select labor'
                                    }],
                                })(
                                    <LaborNameFilter onRef={ref => (this.labor_name = ref)}/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-6 col-12">
                        <div className="floating-label">
                            <FormItem label="Description">
                                {getFieldDecorator('description', {
                                    rules: [{
                                        required: true,
                                        message: 'Please enter description'
                                    }]
                                })
                                (<Input.TextArea autosize placeholder={"Enter Here"}/>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Unit of Time">
                                {getFieldDecorator('uot', {
                                    rules: [{required: true, message: 'Please Enter Unit of measure'}],
                                })(<Select mode="default" placeholder="Select Unit Of Measure"
                                           style={{width: "100%"}}>
                                    <Option key="hour">Hour</Option>
                                    <Option key="day">Day</Option>
                                </Select>)}
                            </FormItem>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Amount of Time">
                                {getFieldDecorator('time', {
                                    rules: [{required: true, message: 'Please Enter Time'}],
                                })(<InputNumber addonAfter={"Hours"}/>)}
                            </FormItem>
                        </div>
                    </div>
                    {data.length < 1 &&
                    <div className="col-sm-4 col-12">
                        <div className="floating-label">
                            <FormItem label="Custom Cost ">
                                {getFieldDecorator('custom_cost')(<InputNumber style={{width: '100%'}}/>)}
                            </FormItem>
                        </div>
                    </div>}
                </div>
                <div className="col-12 add-btn">
                    <Button type="primary" htmlType={"button"} onClick={this.handleLaborSubmit}>{btn_text}</Button>
                </div>
                {data.length > 0 &&
                <div className="added-serv-record">
                    {data.map((item, index) => {
                        return <div key={index} className="row m-0">
                            <div className="col-12 added-service-info">
                                <Button className="edit-gen-btn delete-red-btn" onClick={() => this.removeData(item)}><i
                                    className="fa fa-trash"/>
                                </Button>
                                <Button className="edit-gen-btn" onClick={() => this.fillUpdateFields(item)}><i
                                    className="fa fa-pencil"/></Button>
                                <ul>
                                    <li><span>Labor Name:</span>{item.labor_name.label}</li>
                                    <li><span>Description:</span> {item.description}</li>
                                    <li><span>UOT:</span> {item.uot}</li>
                                    <li><span>Amount of Time:</span> {item.time}</li>
                                </ul>
                            </div>
                        </div>
                    })}
                </div>}
            </div>

        )
    }
}

export const Labor = Form.create()(LaborForm);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/tabs/Labor.jsx